import { useFormikContext } from 'formik'
import type { FieldProps } from 'formik'
import React from 'react'
import { Editor } from '../components/Editor'
import type { EditorProps } from '../components/Editor'

export interface FormikHtmlEditorProps extends FieldProps<any>, Omit<EditorProps, 'form' | 'classes'> {}

/**
 * Helper component to use with a Formik <Field />
 */
const FormikHtmlEditor = ({ form, field, debounce = null, ...props }: FormikHtmlEditorProps) => {
  const { errors } = useFormikContext()
  return (
    <Editor
      {...field}
      {...props}
      content={field?.value ?? ''}
      onChange={(value) => form.setFieldValue(field.name, value)}
      debounce={debounce}
      error={errors?.[field.name] as string | undefined}
    />
  )
}

export default FormikHtmlEditor
